import React, { useEffect, useRef, useState } from "react";
import UnAuthComponent from "../layout/unauth.component";
import { ViewTextLabels, appNote, buttonLabels } from "../shared/constants";
import { ArrowForwordIcon, FbIcon, GoogleLoginIcon, InstaIcon, LinkdinIcon, MicrosoftLoginIcon2, WebIcon, YoutubeIcon, FalkonchatIcon, FalkonchatEmailSucessIcon, LoginBgMobile } from "../../icon";
import { Checkbox, FormControlLabel, FormHelperText, TextField, Tooltip, Zoom } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { AppRoutes } from "../routes/route.path";
import { validateForm } from "../shared/form-validation";
import ButtonComponent from "../shared/button/button.component";
import { useSelector } from "react-redux";
import * as selector from '../../selectors/selectors';
import axios from "axios";
import Config from "../../config";
import setToast from "../../helpers/toaster.helper";
import { ToasterType } from "../shared/toaster/toaster.model";
import { ChannelAuthService } from "../../services/ChannelAuthService";
import { ChannelUserService } from "../../services/ChannelUserService";
import LoginTopCurves from "../../icons/login-background-top-curves.svg";
import LoginBottomCurves from "../../icons/login-background-bottom-curves.svg";
import FalkonchatLoginIcon from "../../icons/channels-login-icon.svg";
import FalkonchatSignUpIcon from "../../icons/channels-signup-icon.svg";

const ChannelsSignUpComponent: React.FC = () => {
    const navigate = useNavigate();
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const IsTeamsApp: boolean = useSelector(selector.isTeamsApp);
    const IsWordPress: boolean = useSelector(selector.IsWordpress)
    const IsShopify: boolean = useSelector(selector.IsShopify)

    const [isVerifyEmail, setIsVerifyEmail] = useState<boolean>(false)
    const [state, setState] = useState({
        firstName: "",
        lastName: "",
        email: "",
        PrivactPolicyAccepted: true,
        errors: {
            email: "",
            firstName: "",
            lastName: ""
        },
        IsLoading: false,
        hostingEnvironment: 'unknown',
        verifyEmailErrormsg: "",
    });

    const sliderRef = useRef();

    useEffect(() => {
        const slider: any = sliderRef.current;
        let interval = setInterval(() => {
            if (slider) {
                slider.scrollBy({ left: slider.offsetWidth, behavior: 'smooth' });
                if (slider.scrollLeft + slider.offsetWidth >= slider.scrollWidth) {
                    slider.scrollTo({ left: 0, behavior: 'smooth' });
                }
            }
        }, 3000);

        return () => clearInterval(interval);
    }, []);

    const socialLogins = [
        { Name: "Google", Icon: <GoogleLoginIcon className="mr-2 h-p-100" />, onclick: () => ChannelAuthService.getGoogleUrl(window.location.pathname.startsWith("/teams"), navigate) },
        { Name: "Microsoft", Icon: <MicrosoftLoginIcon2 className="mr-2 h-p-100" />, onclick: () => ChannelAuthService.getMicrosoftUrl(window.location.pathname.startsWith("/teams"), navigate) }
    ]

    const handleChange = (name: string, value: any) => {
        let Errors = state.errors
        validateForm({ [name]: value },
            (errors) => {
                Errors = { ...Errors, ...errors }
            })
        setState({ ...state, [name]: value, errors: { ...state.errors, ...Errors } });
    };

    const handleVerify = () => {
        if (validateForm({ firstName: state.firstName, lastName: state.lastName, email: state.email }, (Errors) => setState({ ...state, errors: { ...state.errors, ...Errors } }))) {
            setState({ ...state, IsLoading: true })
            let data = {
                "first_name": state.firstName,
                "last_name": state.lastName,
                "email": state.email
            }
            axios.post(`${Config.FALKON_CONNECT_API}/api/v1/user/signup`, data).then((res) => {
                setIsVerifyEmail(true)
                setState({ ...state, IsLoading: false })
            }).catch((err) => {
                setState({ ...state, IsLoading: false, verifyEmailErrormsg: err.response.data?.error?.split(":")[1] })
                setToast(err.response.data?.error?.split(":")[1], ToasterType.DANGER)
            })
        }
    }

    const backToSignUp = () => {
        setIsVerifyEmail(false);
        setState({ ...state, firstName: "", lastName: "", email: "" });
    }

    useEffect(() => {
        if (!!ChannelAuthService.isUserLoggedIn()) {
            navigate(ChannelUserService.hasSysAdminRole() ? AppRoutes.CHANNELS_ORGANISATIONS : AppRoutes.CHANNELS_DASHBOARD)
        }
        else {
            navigate(AppRoutes.CHANNELS_SIGN_UP);
            localStorage.removeItem("user-token")
            localStorage.removeItem("current-user")
            localStorage.removeItem("Timezone")
            localStorage.removeItem("IsLiveChat")
        }
    }, [])


    return (
        <div className={`d-flex w-p-100 h-v-100 ${IsMobileDevice && "flex-direction"}`}>
            {!isVerifyEmail ?
                <>
                    {!IsMobileDevice &&
                        <div className="w-p-45 h-p-100 bg-color-login-left-background d-flex flex-direction">
                            <div className={`h-p-10 d-flex align-end pl-6`}>
                                <FalkonchatIcon />
                            </div>
                            <div className="d-flex flex-direction w-p-100 h-p-75 slider" ref={sliderRef}>
                                <div className="w-p-100 h-p-100 d-flex">
                                    <div className="h-p-100 w-p-100 d-flex flex-direction slide" >
                                        <div className="w-p-100 h-p-25 d-flex flex-direction justify-center align-center">
                                            <div className={"h1-semibold color-primary-accent w-space w-p-100 t-align-center"}>
                                                Engage,Convert,Repeat:
                                            </div>
                                            <div className={"h1-semibold color-primary-accent w-space w-p-100 t-align-center"}>
                                                Boost sales with Falkon Chat
                                            </div>
                                            <div className={"h5-medium color-primary-accent w-space w-p-100 t-align-center mt-1"}>
                                                provide immediate assistance with omnichannel live chat,
                                            </div>
                                            <div className={"h5-medium color-primary-accent w-space w-p-100 t-align-center"}>
                                                resolving customer queries in real-time.
                                            </div>
                                        </div>
                                        <div className="d-flex justify-center align-center h-p-75 w-p-100">
                                            <img src={FalkonchatLoginIcon} className="h-p-100 w-p-100" />
                                        </div>
                                    </div>
                                    <div className="h-p-100 w-p-100 d-flex flex-direction slide" >
                                        <div className="w-p-100 h-p-25 d-flex flex-direction justify-center align-center">
                                            <div className={"h1-semibold color-primary-accent w-space w-p-100 t-align-center"}>
                                                Turn a curious Visitor
                                            </div>
                                            <div className={"h1-semibold color-primary-accent w-space w-p-100 t-align-center"}>
                                                into a valuable customer
                                            </div>
                                            <div className={"h5-medium color-primary-accent w-space w-p-100 t-align-center mt-1"}>
                                                connect with website visitors exactly when
                                            </div>
                                            <div className={"h5-medium color-primary-accent w-space w-p-100 t-align-center"}>
                                                they,re browsing your product or services.
                                            </div>
                                        </div>
                                        <div className="d-flex justify-center align-center h-p-75 w-p-100">
                                            <img src={FalkonchatSignUpIcon} className="h-p-90 w-p-100" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="w-p-100 min-h-12 d-flex flex-direction h-p-15">
                                <div className="w-p-100 h-p-20 d-flex justify-center align-center color-login-text-field-font h6-medium">
                                    {/* Download now */}
                                </div>
                                <div className="w-p-60 h-p-40 d-flex align-center justify-around mx-auto">
                                    {/* <div>
                                        <a href='https://www.falkonsms.com/'
                                            data-arrow-index={1}
                                            data-up-arrow-index={1}
                                            data-down-arrow-index={0}
                                            data-left-arrow-index={1}
                                            data-right-arrow-index={2}
                                            className={"text-style"} target="_blank" rel="noopener noreferrer">
                                            <Tooltip title='Website' placement='bottom-end' TransitionComponent={Zoom} classes={{ popper: "tooltip-z-index" }}>
                                                <WebIcon />
                                            </Tooltip>
                                        </a>
                                    </div>
                                    <div >
                                        <a href='https://www.facebook.com/falkonsystems2021'
                                            data-arrow-index={2}
                                            data-up-arrow-index={2}
                                            data-down-arrow-index={0}
                                            data-left-arrow-index={1}
                                            data-right-arrow-index={3}
                                            className={"text-style"} target="_blank" rel="noopener noreferrer">
                                            <Tooltip title='Facebook' placement='bottom' TransitionComponent={Zoom} classes={{ popper: "tooltip-z-index" }}>
                                                <FbIcon />
                                            </Tooltip>
                                        </a>
                                    </div>
                                    <div >
                                        <a href='https://www.linkedin.com/company/falkon-systems/'
                                            data-arrow-index={3}
                                            data-up-arrow-index={3}
                                            data-down-arrow-index={0}
                                            data-left-arrow-index={2}
                                            data-right-arrow-index={4}
                                            className={"text-style"} target="_blank" rel="noopener noreferrer">
                                            <Tooltip title='Linkdin' placement='bottom' TransitionComponent={Zoom} classes={{ popper: "tooltip-z-index" }}>
                                                <LinkdinIcon />
                                            </Tooltip>
                                        </a>
                                    </div>
                                    <div >
                                        <a href='https://www.instagram.com/falkon_systems_/'
                                            data-arrow-index={4}
                                            data-up-arrow-index={2}
                                            data-down-arrow-index={0}
                                            data-left-arrow-index={3}
                                            data-right-arrow-index={5}
                                            className={"text-style"} target="_blank" rel="noopener noreferrer">
                                            <Tooltip title='Instagram' placement='bottom' TransitionComponent={Zoom} classes={{ popper: "tooltip-z-index" }}>
                                                <InstaIcon />
                                            </Tooltip>
                                        </a>
                                    </div>
                                    <div >
                                        <a href='https://www.youtube.com/channel/UCP_hOtnoImVPCleutK9mLtA'
                                            data-arrow-index={5}
                                            data-up-arrow-index={2}
                                            data-down-arrow-index={0}
                                            data-left-arrow-index={4}
                                            data-right-arrow-index={6}
                                            className={"text-style"} target="_blank" rel="noopener noreferrer">
                                            <Tooltip title='Youtube' placement='bottom-start' TransitionComponent={Zoom} classes={{ popper: "tooltip-z-index" }}>
                                                <YoutubeIcon />
                                            </Tooltip>
                                        </a>
                                    </div> */}
                                </div >
                            </div >
                        </div >
                    }
                    {IsMobileDevice &&
                        <div className={`h-p-10 d-flex align-end pl-6`}>
                            <FalkonchatIcon />
                        </div>
                    }
                    {IsMobileDevice &&
                        <div className="p-absolute l-0 b-0" style={{ zIndex: -1 }}>
                            <LoginBgMobile />
                        </div>
                    }
                    <div className={`${IsMobileDevice ? "w-p-100 h-p-90 justify-center" : "h-p-100 w-p-55 justify-flex-end"} d-flex  flex-direction align-center p-relative`}>
                        {
                            !IsMobileDevice &&
                            <div className="p-absolute t-0 l-0 w-30" style={{ zIndex: -1 }}>
                                <img src={LoginTopCurves} alt="" className="w-p-100" />
                            </div>
                        }
                        {
                            !IsMobileDevice &&
                            <div className="p-absolute b-0 r-0 w-60" style={{ zIndex: -1 }}>
                                <img src={LoginBottomCurves} alt="" className="w-p-100" />
                            </div>
                        }
                        <div className={`w-p-100 d-flex flex-direction  ${IsMobileDevice ? "" : "h-p-75 pb-2"}  justify-center`}>
                            <div className={`h-p-10 min-h-10 d-flex justify-center align-start h1-semibold color-login-headers mx-auto ${IsMobileDevice ? "w-p-100" : "w-p-70"}`}>
                                Sign Up to Falkon Chat
                            </div>
                            <div className={`h-p-6 min-h-6 mx-auto ${IsMobileDevice ? "w-p-70" : " min-w-50"}`}>
                                <TextField
                                    autoFocus
                                    error={
                                        !!state.errors.firstName
                                    }
                                    className={`w-p-100 h-p-100 unauth-border ${state.errors.email && "unauth-border-error"}`}
                                    name="firstName"
                                    placeholder="First Name"
                                    variant="standard"
                                    label="First Name*"
                                    fullWidth
                                    value={state.firstName}
                                    onChange={(e) =>
                                        handleChange(e.target.name, e.target.value)
                                    }
                                    InputProps={{ classes: { input: 'h4-regular color-text-field-font' } }}
                                    autoComplete='no'
                                />
                            </div>
                            <div className={`h-p-2 min-h-2 mx-auto ${IsMobileDevice ? "w-p-70" : " min-w-50"}`}>
                                <FormHelperText className="h6-regular color-primary-danger ml-auto">
                                    {state.errors.firstName}
                                </FormHelperText>
                            </div>
                            <div className={`h-p-6 min-h-6 mx-auto ${IsMobileDevice ? "w-p-70" : " min-w-50"}`}>
                                <TextField
                                    error={
                                        !!state.errors.lastName
                                    }
                                    className={`w-p-100 h-p-100 unauth-border ${state.errors.email && "unauth-border-error"}`}
                                    placeholder="Last Name"
                                    name="lastName"
                                    label="Last Name*"
                                    variant="standard"
                                    fullWidth
                                    value={state.lastName}
                                    onChange={(e) =>
                                        handleChange(e.target.name, e.target.value)
                                    }
                                    InputProps={{ classes: { input: 'h4-regular color-text-field-font' } }}
                                    autoComplete='no'
                                />
                            </div>
                            <div className={`h-p-2 min-h-2 mx-auto ${IsMobileDevice ? "w-p-70" : " min-w-50"}`}>
                                <FormHelperText className="h6-regular color-primary-danger ml-auto">
                                    {state.errors.lastName}
                                </FormHelperText>
                            </div>
                            <div className={`h-p-6 min-h-6 mx-auto ${IsMobileDevice ? "w-p-70" : " min-w-50"}`}>
                                <TextField
                                    className={`w-p-100 h-p-100 unauth-border ${state.errors.email && "unauth-border-error"}`}
                                    error={
                                        !!state.errors.email
                                    }
                                    variant="standard"
                                    fullWidth
                                    id="email"
                                    placeholder=""
                                    name="email"
                                    autoComplete={""}
                                    label="Business Email*"
                                    value={state.email}
                                    onChange={(e) => handleChange(e.target.name, e.target.value)}
                                    inputProps={{ tabIndex: 1, "data-arrow-index": 6 }}
                                    InputProps={{
                                        classes: { input: 'h4-regular w-p-100' }
                                    }}
                                />
                            </div>
                            <div className={`h-p-2 min-h-2 mx-auto ${IsMobileDevice ? "w-p-70" : " min-w-50"}`}>
                                <FormHelperText className="h6-regular color-primary-danger ml-auto">
                                    {state.errors.email}
                                </FormHelperText>
                            </div>
                            <div className={`h-p-6 min-h-4 d-flex align-center mx-auto ${IsMobileDevice ? "w-p-70" : " min-w-50"}`}>
                                <Checkbox
                                    checked={state.PrivactPolicyAccepted}
                                    value={state.PrivactPolicyAccepted}
                                    onChange={(e: any) => setState((prevState) => ({ ...prevState, PrivactPolicyAccepted: e.target.checked }))}
                                    inputProps={{ tabIndex: 3, "data-arrow-index": 8, "data-up-arrow-index": 7, "data-down-arrow-index": 9, "data-left-arrow-index": 2, "data-right-arrow-index": 8 } as any}
                                    classes={{ checked: "selected-checkbox" }} name="keepSignedIn" />
                                <span className={`h5-regular color-sign-up-Iaccept-label my-auto`}>I accept the&nbsp;
                                    <a href='https://falkonsystems.com/terms-of-service/'
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className={`color-primary-light h5-regular c-pointer`}>
                                        {buttonLabels.TERMS_OF_SERVICE}
                                    </a>
                                    &nbsp;and&nbsp;
                                    <a href='https://falkonsystems.com/privacy-policy/'
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className={`color-primary-light c-pointer h5-regular`}>
                                        {buttonLabels.PRIVACY_POLICY}
                                    </a>
                                </span>
                            </div>
                            <div className={`mx-auto h-p-6 min-h-6 d-flex align-center ${IsMobileDevice ? "w-p-70" : " min-w-50"}`}>
                                <button
                                    data-arrow-index={9}
                                    data-up-arrow-index={8}
                                    data-down-arrow-index={9}
                                    data-left-arrow-index={2}
                                    data-right-arrow-index={9}
                                    tabIndex={4}
                                    onClick={() => handleVerify()}
                                    className={`c-pointer justify-center d-flex w-space h4-regular w-fill br-2 t-align-center w-p-100 align-center h-p-80 ${state.PrivactPolicyAccepted ? "bg-color-login-btn color-secondary" : "disabled-btn"}`}>
                                    {state.IsLoading && <span className="mr-1 loader-primary my-auto"></span>}
                                    <span className={"my-auto mr-1"}>Verify Email</span>
                                    <ArrowForwordIcon />
                                </button>
                            </div>
                            <div className={`h-p-6 min-h-4 d-flex justify-center align-center h5-regular color-primary-accent mx-auto w-space ${IsMobileDevice ? "w-p-70" : " min-w-50"} mt-1`}>
                                <span >
                                    {appNote.ALREADY_HAVE_AN_ACCOUNT}&nbsp;&nbsp;
                                </span>
                                <span>
                                    <Link tabIndex={5}
                                        data-arrow-index={10}
                                        data-up-arrow-index={6}
                                        data-down-arrow-index={7}
                                        data-left-arrow-index={2}
                                        data-right-arrow-index={10}
                                        to={AppRoutes.CHANNELS_SIGN_IN} className={"color-login-link c-pointer text-style w-space m-auto"}> {ViewTextLabels.SIGN_IN}
                                    </Link>
                                </span>
                            </div>

                            {!IsWordPress && !IsShopify &&
                                <div className={`h-2 mb-3 mx-auto d-flex justify-center h5-regular ${IsMobileDevice ? "w-p-70" : " min-w-50"}`}>
                                    <div className={`h-2 mx-auto bb-primary-background-pink-4 d-flex justify-center h5-regular w-p-40`}>
                                    </div>
                                    <div className=" min-w-20 h-2 d-flex justify-center align-center p-relative t-1 color-primary-accent w-space w-p-20">
                                        or connect with
                                    </div>
                                    <div className={`h-2 mx-auto bb-primary-background-pink-4 d-flex justify-center h5-regular w-p-40`}>
                                    </div>
                                </div>
                            }

                            {!IsWordPress && !IsShopify &&
                                socialLogins.map((x) => {
                                    return (
                                        <div className={`mx-auto h-p-6 min-h-6 d-flex align-center ${IsMobileDevice ? "w-p-70" : " min-w-50"} c-pointer`} onClick={x.onclick}>
                                            <div className="social-login-button w-p-100 h-p-80 color-microsoft-inactive-email h5-medium">
                                                {x.Icon} Login with {x.Name}
                                            </div>
                                        </div>)
                                })
                            }
                        </div>
                        {!IsMobileDevice &&
                            <div className={`mx-auto d-flex flex-direction align-center ${IsMobileDevice ? "w-p-80" : " min-w-50 min-h-12 h-p-15"}`}>
                                <div className={`h-p-20 w-p-100 d-flex align-end justify-around h6-medium ${IsMobileDevice ? "w-p-80" : " min-w-50"}`}>
                                    <div   >
                                        <a href='https://falkonsystems.com/terms-of-service/'
                                            target="_blank"
                                            data-arrow-index={3}
                                            data-up-arrow-index={1}
                                            data-down-arrow-index={1}
                                            data-left-arrow-index={5}
                                            data-right-arrow-index={4}
                                            className={"text-style color-login-text-field-font w-space f-link-hover"} rel="noopener noreferrer">
                                            {buttonLabels.TERMS_OF_SERVICE}
                                        </a>
                                    </div>
                                    <div   >
                                        <a href='https://falkonsystems.com/privacy-policy/'
                                            target="_blank"
                                            data-arrow-index={4}
                                            data-up-arrow-index={2}
                                            data-down-arrow-index={2}
                                            data-left-arrow-index={3}
                                            data-right-arrow-index={5}
                                            className={"text-style color-login-text-field-font w-space f-link-hover"} rel="noopener noreferrer">
                                            {buttonLabels.PRIVACY_POLICY}
                                        </a>
                                    </div>
                                    <div   >
                                        <a href='https://falkonsystems.com/acceptable-use-policy/'
                                            target="_blank"
                                            data-arrow-index={5}
                                            data-up-arrow-index={2}
                                            data-down-arrow-index={4}
                                            data-left-arrow-index={4}
                                            data-right-arrow-index={9}
                                            className={"text-style color-login-text-field-font w-space f-link-hover"} rel="noopener noreferrer">
                                            {"Acceptable Use Policy"}
                                        </a>
                                    </div>
                                </div>

                                <div className={`h-p-40 min-h-6 d-flex align-center justify-around mx-auto ${IsMobileDevice ? "w-p-80" : " min-w-30 max-w-30"}`}>
                                    {/* <div>
                                        <a href='https://www.falkonsms.com/'
                                            data-arrow-index={1}
                                            data-up-arrow-index={1}
                                            data-down-arrow-index={0}
                                            data-left-arrow-index={1}
                                            data-right-arrow-index={2}
                                            className={"text-style"} target="_blank" rel="noopener noreferrer">
                                            <Tooltip title='Website' placement='bottom-end' TransitionComponent={Zoom} classes={{ popper: "tooltip-z-index" }}>
                                                <WebIcon />
                                            </Tooltip>
                                        </a>
                                    </div> */}
                                    <div >
                                        <a href='https://www.facebook.com/falkonsystems2021'
                                            data-arrow-index={2}
                                            data-up-arrow-index={2}
                                            data-down-arrow-index={0}
                                            data-left-arrow-index={1}
                                            data-right-arrow-index={3}
                                            className={"text-style"} target="_blank" rel="noopener noreferrer">
                                            <Tooltip title='Facebook' placement='bottom' TransitionComponent={Zoom} classes={{ popper: "tooltip-z-index" }}>
                                                <FbIcon />
                                            </Tooltip>
                                        </a>
                                    </div>
                                    <div >
                                        <a href='https://www.linkedin.com/company/falkon-systems/'
                                            data-arrow-index={3}
                                            data-up-arrow-index={3}
                                            data-down-arrow-index={0}
                                            data-left-arrow-index={2}
                                            data-right-arrow-index={4}
                                            className={"text-style"} target="_blank" rel="noopener noreferrer">
                                            <Tooltip title='Linkdin' placement='bottom' TransitionComponent={Zoom} classes={{ popper: "tooltip-z-index" }}>
                                                <LinkdinIcon />
                                            </Tooltip>
                                        </a>
                                    </div>
                                    {/* <div >
                                        <a href='https://www.instagram.com/falkon_systems_/'
                                            data-arrow-index={4}
                                            data-up-arrow-index={2}
                                            data-down-arrow-index={0}
                                            data-left-arrow-index={3}
                                            data-right-arrow-index={5}
                                            className={"text-style"} target="_blank" rel="noopener noreferrer">
                                            <Tooltip title='Instagram' placement='bottom' TransitionComponent={Zoom} classes={{ popper: "tooltip-z-index" }}>
                                                <InstaIcon />
                                            </Tooltip>
                                        </a>
                                    </div> */}
                                    <div >
                                        <a href='https://www.youtube.com/channel/UCP_hOtnoImVPCleutK9mLtA'
                                            data-arrow-index={5}
                                            data-up-arrow-index={2}
                                            data-down-arrow-index={0}
                                            data-left-arrow-index={4}
                                            data-right-arrow-index={6}
                                            className={"text-style"} target="_blank" rel="noopener noreferrer">
                                            <Tooltip title='Youtube' placement='bottom-start' TransitionComponent={Zoom} classes={{ popper: "tooltip-z-index" }}>
                                                <YoutubeIcon />
                                            </Tooltip>
                                        </a>
                                    </div>
                                </div >
                            </div>
                        }
                    </div >
                </>
                :
                <div className={`d-flex  br-4 login-background flex-direction align-center bg-color-login ${IsMobileDevice ? "w-p-90 login-border m-auto h-p-70 justify-between" : "w-p-100 h-p-90"}`}>
                    <FalkonchatIcon className="py-3" />
                    <div className="h2-medium">
                        Verify your email
                    </div>
                    <div className={`color-email-sent-displaymsg h4-regular py-1 ${IsMobileDevice ? "w-p-90" : ""}`}>
                        Check your email & click the link to activate your account
                    </div>
                    <FalkonchatEmailSucessIcon width={300} height={300} />
                    <div className="d-flex justify-arround">
                        <ButtonComponent ButtonLabel={"Resend email"} Variant={"primary-btn"} ClassName="mr-2" OnClick={() => handleVerify()} Loading={state.IsLoading} />
                        <ButtonComponent ButtonLabel={"Back to sign-up"} Variant={"secondary-btn"} OnClick={() => backToSignUp()} />
                    </div>
                    <a className={`color-login-text-field-font h4-regular f-link-hover underline ${IsMobileDevice ? "mb-2" : ""}`} href="https://share.hsforms.com/1uSaLr6GxTn-Mqid2VwLqzgcauh6">Contact support</a>
                </div>
            }
        </div >
    )
}

export default (ChannelsSignUpComponent);